<template>
  <div>
    <el-button-group class="button-group">
      <el-button type="default" @click="showModal()">
        + Dodaj kategorię wydarzenia
      </el-button>
    </el-button-group>
    <el-dialog
      title="Tworzenie nowej kategorii"
      append-to-body
      width="90vw"
      top="4vh"
      :visible.sync="modalVisible"
    >
      <event-category-form in-modal @submit="submitForm()" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideModal()">Anuluj</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EventCategoryForm from '../EventCategoryForm'

export default {
  components: { EventCategoryForm },
  data() {
    return {
      modalVisible: false
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    hideModal() {
      this.modalVisible = false
    },
    submitForm() {
      this.hideModal()
      this.$emit('reload')
    }
  }
}
</script>
<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: flex-end;
}
</style>
